var map = {
	"./axis-realty-group-banner-1.jpg": "5f0b",
	"./axis-realty-group-banner-2.jpg": "d517",
	"./axis-realty-group-banner-3.jpg": "5608",
	"./axis-realty-group-banner-4.jpg": "cdd7",
	"./axis-realty-group-banner-5.jpg": "e8ca",
	"./axis-realty-group-banner-6.jpg": "75a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0001";